import type React from "react";
import type { FC } from "react";

interface DropdownClearButtonProps {
	onClear: (e: React.MouseEvent<HTMLButtonElement>) => void;
	dataTestID?: string;
}

const DropdownClearButton: FC<DropdownClearButtonProps> = ({ onClear, dataTestID }) => {
	return (
		<button
			onClick={onClear}
			type="button"
			data-testid={dataTestID ?? "common-dropdown-clear-button"}
			className="absolute right-[30px] top-[35%] -translate-y-1/2 z-0 p-0
             h-5 w-5 rounded-full bg-blue-600 flex items-center justify-center 
             cursor-pointer hover:bg-blue-600"
		>
			<span className="icon-close text-white text-sm font-bold"></span>
		</button>
	);
};

export default DropdownClearButton;
